/**
 * Standardise vehicle ID for display and matching across Profitability Report and Cost Manage.
 * - Trims whitespace
 * - Removes trailing " 2" suffix (e.g. "BD22ASZ 2" -> "BD22ASZ")
 * - Removes trailing "2" suffix (e.g. "P888RNW2" -> "P888RNW") so variants with an extra "2" match the main reg
 * - Collapses all internal spaces (for consistent matching with vehicle list which often has no spaces)
 */
export function standardiseVehicleId(id: string | undefined | null): string {
  if (id == null || typeof id !== 'string') return '';
  let s = id.trim();
  if (s.endsWith(' 2')) s = s.slice(0, -2).trim();
  s = s.replace(/\s+/g, '');
  if (s.endsWith('2') && s.length > 1) s = s.slice(0, -1);
  return s;
}

/**
 * Truth-layer entity IDs are Crockford Base32 ULIDs (26 chars).
 * Geographic Insights sometimes fall back to these when registration is unresolved,
 * producing duplicate Vehicle dropdown entries alongside real vehicle regs.
 */
export function isEntityUlid(id: string | undefined | null): boolean {
  if (id == null || typeof id !== 'string') return false;
  return /^[0-9A-HJKMNP-TV-Z]{26}$/i.test(id.trim());
}

/** Prefer vehicle regs / types; drop unresolved entity ULIDs from Vehicle Value lists. */
export function filterVehicleGroupKeys(keys: string[], groupBy: string): string[] {
  if (groupBy !== 'Vehicle') return keys;
  return keys.filter((k) => !isEntityUlid(k));
}
